<template>
  <v-row justify="center">
    <v-dialog
      style="border-radius: 5px"
      v-model="show"
      persistent
      max-width="600px"
    >
      <custom-modal
        title="Edit Ingredient"
        @onSubmit="SaveIngredients"
        @onClose="close"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-row>
            <v-col cols="8">
              <ValidationProvider
                v-slot="{ errors }"
                name="Name"
                vid="name"
                rules="required|no_spaces_only"
                hide-details="auto"
              >
                <v-text-field
                  hide-details="auto"
                  :error-messages="errors"
                  required
                  label="Name"
                  v-model="Ingredients.name"
                  auto-grow
                  outlined
                  @blur="Ingredients.name = Ingredients.name.trim()"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12 pb-0">
              <v-flex class="pt-0 pa-3">
                <FileUpload
                  title="Image"
                  :multiple="false"
                  v-model="selectedImages"
                  :externalFiles="Ingredients.image ? [Ingredients.image] : []"
                  @isImageUpdated="onChangeImageUpload"
                  ref="imageInput"
                  size="10000"
                  :types="['jpeg', 'png']"
                  :showPreview="true"
                />
              </v-flex>
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import FileUpload from "@/components/base/FileUpload";
import { mapState } from "vuex";
import CustomModal from "@/components/base/CustomModal";
import { required, email, max } from "vee-validate/dist/rules";
import _ from "lodash";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("no_spaces_only", {
  validate: (value) => {
    return value && value.trim().length > 0;
  },
  message: "{_field_} cannot be empty or spaces only",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
    dialog: false,
    selectedImages: "",
    existImage: [],
    options: [],
    isLoading: false,
    imageUpdated: null,
    pagination1: {
      descending: true,
      page: 1,
      rowsPerPage: 2,
      sortBy: "fat",
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pagination: {
      page: 1,
      itemsPerPage: 2,
    },
    page: 1,
    Designtion: {
      name: "",
    },

    value: [],
    options: [],
    isLoading: false,
  }),

  name: "Add Employe",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    Ingredients: {
      type: Object,
      default: {},
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    CustomModal,
    FileUpload,
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    refreshImage() {
      this.$refs.imageInput.GetImage();
    },
    close() {
      this.show = false;

      this.$refs.observer.reset();
    },
    onChangeImageUpload(value) {
      this.imageUpdated = value;
    },

    async UploadImage(id) {
      let formData = new FormData();

      if (this.selectedImages && this.imageUpdated) {
        formData.append("id", this.Ingredients.id);
        formData.append("image", this.selectedImages);
        return await this.$store.dispatch(
          "ingredients/UploadIngredientImage",
          formData
        );
      } else if (this.imageUpdated == false) {
        formData.append("id", this.Ingredients.id);
        formData.append("image", null);
        return await this.$store.dispatch(
          "ingredients/UploadIngredientImage",
          formData
        );
      } else {
        return true;
      }
    },
    async SaveIngredients() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.UpdateIngredients();
      }
    },

    UpdateIngredients() {
      this.isLoading = true;
      const credential = this.Ingredients;

      this.$store
        .dispatch("ingredients/UpdateIngredients", {
          data: {
            id: credential.id,
            name: credential.name,
          },
        })
        .then(async (res) => {
          await this.UploadImage(credential.id)
            .then((res) => {})
            .catch((err) => {
              this.$refs.observer.setErrors(err.data.error);
              this.messages = err.data.title;
              this.$toast.error("Ingredient image upload failed");
            });
          // }

          this.succeeed = true;
          this.$emit("afterSave");
          this.$toast.success("Ingredients edited  succesfully");

          this.isLoading = false;
          this.show = false;

          this.$refs.observer.reset();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$refs.observer.setErrors(err.data.error);

          this.$toast.error("Ingredients edited  failed!");
          this.isLoading = false;
        });
    },
  },
};
</script>
